<app-modal-refactor
  [size]="'lg'"
  [showImage]="true"
  [image]="icon"
  [isVerPass]="true"
  [imageClose]="'../../../assets/images/Close_modal.svg'"
  [showImageClose]="true"
>
  <div body class="bagtagLowPaper">
    <span class="bagtagLowPaper-title gapline">{{ titleKey | translate }}</span>

    <span class="bagtagLowPaper-body gapline">{{ bodyKey | translate }}</span>

    <div class="bagtagLowPaper-actions gapline">
      <button type="button" class="bagtagLowPaper-btn search-bg white-font" (click)="onContinue()">
        <div class="bagtagLowPaper-btn-container">
          <span>{{ ctaKey | translate }}</span>
        </div>
      </button>
    </div>
  </div>
</app-modal-refactor>
